const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager report component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerUserScorm', ['Application', 'ScormRegistrations', function (Application, ScormRegistrations) {
  return {
    restrict: 'E',
    scope: {
      manager: '=',
      singleUser: '=',
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-user-scorm.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.activeRegistrations = false;
      // Use Scorm Registration resource to query for all scorm items under the selected single user
      self.load = function () {
        self.loading = true;
        var filter = {
          subresource: 'all',
          users: [$scope.singleUser],
          page: self.paginate.page,
          limit: self.paginate.perPage,
          sort: {'createdAt': -1},
        };
        ScormRegistrations.find(filter).$promise.then(function (registrations) {
          if (registrations.length) {
            self.registrations = registrations;
            self.activeRegistrations = true;
          }
          if (!registrations.length && self.activeRegistrations) {
            self.paginate.emptyPage = true;
            self.paginate.page--;
          }
          self.loading = false;
        })
      }

      // Handle pagination
      self.paginate = {
        perPage: 10,
        page: 1,
        emptyPage: false,
        nextPage: function () {
          this.page++;
          self.load();
        },
        previousPage: function () {
          if (this.emptyPage) {
            this.emptyPage = false;
          }
          this.page--;
          self.load();
        }
      }

      // Handle navigation to view selected scorm
      self.navScorm = function (item) {
        var type = 'scorm';
        var id = item.content._id;
        if (!id) {
          return;
        }
        Application.navigation.goTo('/view/' + type + '/' + id);
      };

      // Format time spent on content
      self.timeSpent = function (seconds_spent) {
        var seconds = parseInt(seconds_spent, 10);

        var days = Math.floor(seconds / (3600 * 24));
        seconds -= days * 3600 * 24;
        var hrs = Math.floor(seconds / 3600);
        seconds -= hrs * 3600;
        var mnts = Math.floor(seconds / 60);
        seconds -= mnts * 60;
        if (days > 0) {
          return days + "d " + hrs + "h " + mnts + "m " + seconds + "s";
        }
        if (hrs > 0) {
          return hrs + "h " + mnts + "m " + seconds + "s";
        }
        if (mnts > 0) {
          return mnts + "m " + seconds + "s";
        }
        return seconds + "s";
      };

      // Initialize component
      if ($scope.singleUser) {
        self.paginate.page = 1;
        self.load();
      }

      $scope.$watch('singleUser', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          self.paginate.page = 1;
          self.load();
        }
      });
    }],
    controllerAs: 'userScorm'
  };
}]);